var isMobile = /android|ipad|iphone|ipod|android.*mobile|windows.*phone|blackberry.*mobile/i.test(window.navigator.userAgent.toLowerCase()) && !/SPAD/.test(navigator.userAgent);
var isMobileOrElectron = /android|ipad|electron|iphone|ipod|android.*mobile|windows.*phone|blackberry.*mobile/i.test(window.navigator.userAgent.toLowerCase());
export var isDingDing = /DingTalk/i.test(window.navigator.userAgent.toLowerCase());
export var isSSAI = /SSAI_Android|SSAI_iOS$/.test(navigator.userAgent);
export var isJzj = /JZJX_Android$/.test(navigator.userAgent);
var utils = {
    secondToTime: function secondToTime(second) {
        second = second || 0;
        if (second === 0 || second === Infinity || second.toString() === 'NaN') {
            return '00:00';
        }
        var add0 = function add0(num) {
            return num < 10 ? '0' + num : '' + num;
        };
        var hour = Math.floor(second / 3600);
        var min = Math.floor((second - hour * 3600) / 60);
        var sec = Math.floor(second - hour * 3600 - min * 60);
        return (hour > 0 ? [
            hour,
            min,
            sec
        ] : [
            min,
            sec
        ]).map(add0).join(':');
    },
    getElementViewLeft: function getElementViewLeft(element) {
        var actualLeft = element.offsetLeft;
        var current = element.offsetParent;
        var elementScrollLeft = document.body.scrollLeft + document.documentElement.scrollLeft;
        if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
            while (current !== null) {
                actualLeft += current.offsetLeft;
                current = current.offsetParent;
            }
        } else {
            while (current !== null && current !== element) {
                actualLeft += current.offsetLeft;
                current = current.offsetParent;
            }
        }
        return actualLeft - elementScrollLeft;
    },
    getBoundingClientRectViewLeft: function getBoundingClientRectViewLeft(element) {
        var scrollTop = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
        if (element.getBoundingClientRect) {
            if (typeof this.getBoundingClientRectViewLeft.offset !== 'number') {
                var temp = document.createElement('div');
                temp.style.cssText = 'position:absolute;top:0;left:0;';
                document.body.appendChild(temp);
                this.getBoundingClientRectViewLeft.offset = -temp.getBoundingClientRect().top - scrollTop;
                document.body.removeChild(temp);
                temp = null;
            }
            var rect = element.getBoundingClientRect();
            var offset = this.getBoundingClientRectViewLeft.offset;
            return rect.left + offset;
        } else {
            return this.getElementViewLeft(element);
        }
    },
    findPosition: function findPosition(el) {
        var box;
        if (el.getBoundingClientRect && el.parentNode) {
            box = el.getBoundingClientRect();
        }
        if (!box) {
            return {
                left: 0,
                top: 0
            };
        }
        var docEl = document.documentElement;
        var body = document.body;
        var clientLeft = docEl.clientLeft || body.clientLeft || 0;
        var scrollLeft = window.pageXOffset || body.scrollLeft;
        var left = box.left + scrollLeft - clientLeft;
        var clientTop = docEl.clientTop || body.clientTop || 0;
        var scrollTop = window.pageYOffset || body.scrollTop;
        var top = box.top + scrollTop - clientTop;
        return {
            left: Math.round(left),
            top: Math.round(top)
        };
    },
    getPointerPosition: function getPointerPosition(el, event) {
        var position = {};
        var box = this.findPosition(el);
        var boxW = el.offsetWidth;
        var boxH = el.offsetHeight;
        var boxY = box.top;
        var boxX = box.left;
        var pageY = event.pageY;
        var pageX = event.pageX;
        if (event.changedTouches) {
            pageX = event.changedTouches[0].pageX;
            pageY = event.changedTouches[0].pageY;
        }
        position.y = Math.max(0, Math.min(1, (boxY - pageY + boxH) / boxH));
        position.x = Math.max(0, Math.min(1, (pageX - boxX) / boxW));
        return position;
    },
    getScrollPosition: function getScrollPosition() {
        return {
            left: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0,
            top: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
        };
    },
    setScrollPosition: function setScrollPosition(_ref) {
        var _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top;
        if (this.isFirefox) {
            document.documentElement.scrollLeft = left;
            document.documentElement.scrollTop = top;
        } else {
            window.scrollTo(left, top);
        }
    },
    isMobile: isMobile,
    isMobileOrElectron: isMobileOrElectron,
    isDingDing: isDingDing,
    isSSAI: isSSAI,
    isJzj: isJzj,
    isFirefox: /firefox/i.test(window.navigator.userAgent),
    isChrome: /chrome/i.test(window.navigator.userAgent),
    storage: {
        set: function set(key, value) {
            localStorage.setItem(key, value);
        },
        get: function get(key) {
            return localStorage.getItem(key);
        }
    },
    nameMap: {
        dragStart: isMobile ? 'touchstart' : 'mousedown',
        dragMove: isMobile ? 'touchmove' : 'mousemove',
        dragEnd: isMobile ? 'touchend' : 'mouseup'
    },
    color2Number: function color2Number(color) {
        if (color[0] === '#') {
            color = color.substr(1);
        }
        if (color.length === 3) {
            color = ''.concat(color[0]).concat(color[0]).concat(color[1]).concat(color[1]).concat(color[2]).concat(color[2]);
        }
        return parseInt(color, 16) + 0 & 16777215;
    },
    number2Color: function number2Color(number) {
        return '#' + ('00000' + number.toString(16)).slice(-6);
    },
    number2Type: function number2Type(number) {
        switch (number) {
        case 0:
            return 'right';
        case 1:
            return 'top';
        case 2:
            return 'bottom';
        default:
            return 'right';
        }
    },
    isM3u8: function isM3u8(url) {
        return /\.m3u8(#|\?|\.|$)/i.test(url);
    },
    isMp4: function isMp4(url) {
        return /\.mp4(#|\?|\.|$)/i.test(url);
    },
    isAndroid: /Android/i.test(window.navigator.userAgent),
    isPad: /iPad/i.test(window.navigator.userAgent),
    debounce: function debounce(fn, wait) {
        var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var timer, startTimeStamp = 0;
        var context, args;
        var run = function run(timerInterval) {
            timer = setTimeout(function () {
                var now = new Date().getTime();
                var interval = now - startTimeStamp;
                if (interval < timerInterval) {
                    startTimeStamp = now;
                    run(timerInterval - interval);
                } else {
                    if (!immediate) {
                        fn.apply(context, args);
                    }
                    clearTimeout(timer);
                    timer = null;
                }
            }, timerInterval);
        };
        return function () {
            context = this;
            args = arguments;
            var now = new Date().getTime();
            startTimeStamp = now;
            if (!timer) {
                if (immediate) {
                    fn.apply(context, args);
                }
                run(wait);
            }
        };
    },
    throttling: function throttling(fn, wait, immediate) {
        var timer, timeStamp = 0;
        var context, args;
        var run = function run() {
            timer = setTimeout(function () {
                if (!immediate) {
                    fn.apply(context, args);
                }
                clearTimeout(timer);
                timer = null;
            }, wait);
        };
        return function () {
            context = this;
            args = arguments;
            if (!timer) {
                console.log('throttle, set');
                if (immediate) {
                    fn.apply(context, args);
                }
                run();
            } else {
                console.log('throttle, ignore');
            }
        };
    },
    getUuid: function getUuid() {
        var len = 32;
        var radix = 16;
        var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
        var uuid = [], i;
        radix = radix || chars.length;
        if (len) {
            for (i = 0; i < len; i++) {
                uuid[i] = chars[0 | Math.random() * radix];
            }
        } else {
            var r;
            uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
            uuid[14] = '4';
            for (i = 0; i < 36; i++) {
                if (!uuid[i]) {
                    r = 0 | Math.random() * 16;
                    uuid[i] = chars[i == 19 ? r & 3 | 8 : r];
                }
            }
        }
        return uuid.join('');
    }
};
export default utils;